import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { pageContext } from 'ctm-util-functions';

const ResultsControls = ({ layout, pagination }) => {
    return (
        <>
            { pageContext.getProps().director.constructComponents([layout], { ...pagination }) }
        </>
    );
};

ResultsControls.propTypes = {
    pagination: PropTypes.object,
    layout: PropTypes.string.isRequired
};

export { ResultsControls };
